<script>
  import jQuery from 'jquery';
  import Notification from '@utils/notification';

  export let profileUrl;
  export let mobile;

  let copyInput;

  let copy = function () {
    if (mobile && typeof navigator !== 'undefined' && typeof navigator.share != 'undefined') {
      navigator
        .share({ text: profileUrl })
        .then(() => {})
        .catch(() => {});
    } else {
      jQuery(copyInput).val(profileUrl);
      jQuery(copyInput).css('display', 'block');
      copyInput.select();
      copyInput.setSelectionRange(0, 9999);
      document.execCommand('copy');
      jQuery(copyInput).css('display', 'none');
      Notification.send({ text: 'Profile link copied' });
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  @media (min-width: 754px) {
    .ui-code-container {
      &:hover {
        color: $dark-purple !important;
        background-color: $background-purple !important;
      }
    }
  }

  .ui-code-container {
    background: $white;
    display: flex;
    align-items: center;
    cursor: pointer;

    padding: 6px 16px;
    margin-top: 10px;
    border-radius: 8px;

    .ui-code {
      @include color('purple');
      @include typeface-b1($font-weight-medium);
      text-align: center;
      flex: 1;

      .icon {
        margin-bottom: 4px;
        margin-left: 6px;
      }
    }
  }
</style>

<div class="ui-code-container code-only">
  <div class="ui-code" on:click|preventDefault={() => copy()}>
    {profileUrl}
    <img class="icon" alt="copy-icon" src="/images/notifications/copy.svg" />
  </div>
  <input type="text" style="display: none" bind:this={copyInput} />
</div>
